import {
    Scene, 
    Engine, 
    Camera,
    Color4, 
    Color3,
    Vector3, 
    FreeCamera, 
    UniversalCamera,
    HemisphericLight, 
    ShadowLight,
    DirectionalLight,
    PointLight,
    SpotLight,
    MeshBuilder,
    PBRMaterial,
    DynamicTexture,
    Texture,
    SceneLoader,
    AbstractMesh,
    VideoTexture,
    GlowLayer,
    MeshAssetTask,
    ScreenSpaceReflectionPostProcess,
    WebXRHitTest,
    GizmoManager,
    LightGizmo,
    Light,
    ShadowGenerator,
    StandardMaterial,
    MirrorTexture,
    CubeTexture,
    Mesh,
    Plane,
    Material,
    WebVRFreeCamera,
    VRDeviceOrientationFreeCamera,
    KeyboardEventTypes,
    Animatable,
    TransformNode,
    TrajectoryClassifier,
    EasingFunction,
    QuarticEase,
    DefaultRenderingPipeline,
    Animation,
    ArcRotateCamera,
    TouchCamera,
    VirtualJoysticksCamera,
    DeviceOrientationCamera,
    PhysicsImpostor,
    CannonJSPlugin,
    ActionManager,
    SetValueAction,
    ExecuteCodeAction,
    PushMaterial,
    Action,
    PerfCounter,
    StopSoundAction,
    Sound,
    HDRCubeTexture,
    VolumetricLightScatteringPostProcess,
    ScenePerformancePriority,
    } from "@babylonjs/core";
  import "@babylonjs/loaders";
  import { CustomLoading } from "./customLoading";
  import { AdvancedDynamicTexture, Button, GUI3DManager, HolographicButton, Image, StackPanel } from "@babylonjs/gui";
  
  
  export class MobThreshold {
    scene: Scene;
    engine: Engine;  
    loadingScreen: CustomLoading;
    camera!: VirtualJoysticksCamera;
    camera1!: FreeCamera;
    lowRad: number;
    upperRad: number;
    fovAnim!: Animatable;
    VirtualJoysticksCamera: any;
    FreeCamera: any;
    logoImageUp!: Image;
    ScenePerformancePriority: any;
    playButton!: Button;
    playImage!: Image;
  
  constructor(private canvas: HTMLCanvasElement, private loadContainer: HTMLElement, private loadAnim: HTMLElement,) {
      this.engine = new Engine(this.canvas, true, {
        antialias: true,
        // preserveDrawingBuffer: false,
      });
      
    this.engine.setHardwareScalingLevel(0.5);
  
    this.loadingScreen = new CustomLoading(this.loadContainer, this.loadAnim);
  
    this.engine.loadingScreen = this.loadingScreen;
    this.engine.displayLoadingUI();
  
    this.scene = this.CreateScene();
    this.lowRad = 0.3;
    this.upperRad = 2.5;
    this.CreateEnvironment();
    this.CreateCamera();
    // this.PlayButton();
  
    this.engine.runRenderLoop(()=>{
        this.scene.render();
    });
    this.canvas.addEventListener("resize", () => { 
      this.engine.resize(); 
    });
  
    window.addEventListener("resize", () => {
      this.engine.resize();
    });
  }
  CreateScene(): Scene {
    const scene = new Scene(this.engine); 
    const assumedFramesPerSecond = 60;
    const earthGravity = -9.8;
    scene.gravity = new Vector3(0, earthGravity / assumedFramesPerSecond, 0);
    scene.clearColor = new Color4(0, 0, 0, 1);
    // scene.collisionsEnabled = true;
    scene.enablePhysics();
    return scene;
  }
  
  // PlayButton(): void {
  //   const advancedTexture = AdvancedDynamicTexture.CreateFullscreenUI("UI");
  //   advancedTexture.idealWidth = 5000;
  //   advancedTexture.idealHeight = 5000;
    
  //   this.logoImageUp = new Image("playImage", "./assets/textures/play.png");
    
  //   this.logoImageUp.fixedRatio = 1;
  //   this.logoImageUp.height = "160px";
  //   this.logoImageUp.verticalAlignment = 1;
  //   this.logoImageUp.horizontalAlignment = 0;
  //   this.logoImageUp.top = "-90%";
  //   this.logoImageUp.left = "95%";
  //   this.logoImageUp.alpha = 1;
  //   // this.logoImageUp.style.zIndex = "10";
  
  //   advancedTexture.addControl(this.logoImageUp);
  // }
  
  async CreateCamera(): Promise<void> {
    this.camera = new VirtualJoysticksCamera("vrcamera", new Vector3(0, -1, 0), this.scene);
    this.camera.rotation = new Vector3(0, 0, 0);
    this.camera.attachControl(this.canvas, true);
    this.camera.minZ = 0.25;
    this.camera.speed = 0.2;
    this.camera.applyGravity = true;
    this.camera.ellipsoid = new Vector3(0.8, 1, 0.8);
    this.camera.checkCollisions = true;
    this.camera1.onCollide;
  }
  async CreateEnvironment(): Promise<void>{
  
    const model = await SceneLoader.ImportMeshAsync(
      "",
      "./assets/models/",
      "thresholdMob.glb",        
      this.scene,
      (evt) => {
        const loadStatus = (evt.loaded * 100 / evt.total).toFixed();
        this.loadingScreen.updateLoadStatus(loadStatus);
      }
      );
    
    console.log(model.transformNodes, model.meshes);
    for(let i = 0; i < model.meshes.length; i++) {
      if(i != 1) model.meshes[i].checkCollisions = true;
    }
  
    const dirLight = new DirectionalLight("dirLight", new Vector3(0,1,0), this.scene,)
    dirLight.diffuse = new Color3(1,1,1);
    dirLight.intensity = 1.5;
    const hemiLight = new HemisphericLight("hemiLight", new Vector3(0,1,0), this.scene);
    hemiLight.intensity = 1.8;
    hemiLight.diffuse = new Color3(1,1,1);
  
    const music = new Sound("music", "./assets/models/Threshold.mp3", this.scene, function() {
        music.autoplay = true;
        music.play();
        music.loop;
        music.setVolume(0.5);
      }
      );
      const glass = new PBRMaterial("cubeMat4", this.scene);
      glass.alpha = 0;
      glass.metallic = 0;
      glass.roughness = 10;
      model.meshes[13].material = glass;  
      model.meshes[25].material = glass;
      model.meshes[10].material = glass;
  
  
      const displayMat1 = new PBRMaterial("displayMat1", this.scene);
      const displayTex1 = new VideoTexture(
        "displayTex1", 
        "./assets/models/ThresholdMob.mp4", 
        this.scene, 
        true,
        true, 
        VideoTexture.BILINEAR_SAMPLINGMODE, {
          autoUpdateTexture: true,
          autoPlay: false,
          loop: true
        });
      displayTex1.getAlphaFromRGB = true;
      displayMat1.alphaMode = Engine.ALPHA_ONEONE;
      displayMat1.opacityTexture = displayTex1;
      displayMat1.reflectanceTexture = displayTex1;
      displayMat1.reflectionColor = Color3.Black();
      displayMat1.backFaceCulling = false;
      displayMat1.metallic = 0;
      displayMat1.albedoColor = Color3.Black();
      displayMat1.emissiveColor = new Color3(1, 1, 1);
      displayMat1.emissiveIntensity = 1;
      displayMat1.emissiveTexture = displayTex1; 
      displayTex1.video.preload = "auto";
  
    const btn = document.createElement("button")
    btn.innerText = "Play"
    btn.style.zIndex = "10"
    btn.style.position = "absolute"
    btn.style.bottom = "1vh"
    btn.style.right = "1vw"
    btn.style.backgroundColor = "rgba(0,0,0,0)"
    btn.style.color = "White"
    btn.style.fontFamily = "'Bebas Neue', bold"
    btn.style.fontSize = "5vh"
    btn.style.borderColor  = "rgba(0,0,0,0)"
    document.body.appendChild(btn)
  
    btn.onclick = ()=>{
        displayTex1.video.play();
        model.meshes[10].material = displayMat1;
        music.stop();
      }
      const uvScale = 30;
      const texArray: Texture[] = [];
    
      const uvScalee = 7;
      const texArrayy: Texture[] = [];
    
      const uvScaleee = 60;
      const texArrayyy: Texture[] = [];
  
      const wall = new StandardMaterial("cubeMat11", this.scene);
      const diffuseTexwall = new Texture("./assets/textures/1k/wall_in.jpg",this.scene,false,false);
      wall.diffuseTexture = diffuseTexwall;
      diffuseTexwall.getAlphaFromRGB = false;
      wall.specularColor = new Color3(0,0,0);
      const aoTexwall = new Texture("./assets/textures/1k/beige_wall_001_ao_4k.jpg", this.scene);
      wall.ambientTexture = aoTexwall;
      texArray.push(aoTexwall);
      model.meshes[7].material = wall; 
  
      const room_floor = new StandardMaterial("cubeMat1", this.scene);
      const diffuseTexroom_floor = new Texture("./assets/textures/1k/room_floor.jpg",this.scene,false,false);
      diffuseTexroom_floor.getAlphaFromRGB = false;
      room_floor.diffuseTexture = diffuseTexroom_floor;
      room_floor.roughness = 1;
      room_floor.backFaceCulling = true;
      room_floor.specularColor = new Color3(0,0,0);
      const aoTexroom_floor = new Texture("./assets/textures/1k/beige_wall_001_ao_4k1.jpg", this.scene);
      room_floor.ambientTexture = aoTexroom_floor;
      texArrayy.push(aoTexroom_floor);
      model.meshes[6].material = room_floor;
  
      const platform_floor = new StandardMaterial("cubeMat1", this.scene);
      const diffuseTexplatform_floor = new Texture("./assets/textures/1k/platform_floor.jpg",this.scene,false,false);
      diffuseTexplatform_floor.getAlphaFromRGB = false;
      platform_floor.diffuseTexture = diffuseTexplatform_floor;
      platform_floor.roughness = 1;
      platform_floor.backFaceCulling = true;
      platform_floor.specularColor = new Color3(50/255,50/255,50/255);
      platform_floor.ambientTexture = diffuseTexplatform_floor;
      platform_floor.reflectionTexture = diffuseTexplatform_floor;
      platform_floor.useReflectionOverAlpha = true;
      const aoTexplatform_floor = new Texture("./assets/textures/1k/beige_wall_001_ao_4k4.jpg", this.scene);
      platform_floor.ambientTexture = aoTexplatform_floor;
      texArrayy.push(aoTexplatform_floor);
      platform_floor.reflectionTexture = new MirrorTexture("mirror", {ratio: 1}, this.scene, true);
      (platform_floor.reflectionTexture as MirrorTexture).renderList = [model.meshes[10]];
      (platform_floor.reflectionTexture as MirrorTexture).mirrorPlane = new Plane(0, -1, 0, -3.5);
      (platform_floor.reflectionTexture as MirrorTexture).adaptiveBlurKernel = 128;
      (platform_floor.reflectionTexture as MirrorTexture).level = 0.5;
      model.meshes[4].material = platform_floor;
  
      texArray.forEach((tex) => {
        tex.uScale = uvScale;
        tex.vScale = uvScale;
      });
    
      texArrayy.forEach((tex) => {
        tex.uScale = uvScalee;
        tex.vScale = uvScalee;
      });
    
      texArrayyy.forEach((tex) => {
          tex.uScale = uvScaleee;
          tex.vScale = uvScaleee;
        });
  
        const text = new StandardMaterial("cubeMat11", this.scene);
        const diffuseTextext = new Texture("./assets/textures/inscription.png",this.scene,false,false);
        text.diffuseTexture = diffuseTextext;
        text.diffuseTexture.hasAlpha = true;
        text.alpha = 1;
        model.meshes[24].material = text;  
  
        const spher = new StandardMaterial("cubeMat11111", this.scene);
        const diffuseTexspher = new Texture("./assets/textures/1k/background.jpg",this.scene,false,false);
        spher.diffuseTexture = diffuseTexspher;  
        spher.specularColor = new Color3(0,0,0);
        model.meshes[1].material = spher;
    
  
        const pic1 = new StandardMaterial("cubeMat11", this.scene);
        const diffusepic1 = new Texture("./assets/textures/1k/1B.jpg",this.scene,false,false);
        pic1.diffuseTexture = diffusepic1;
        pic1.diffuseTexture.hasAlpha = true;
        model.meshes[2].material = pic1;  
    
        const pic2 = new StandardMaterial("cubeMat11", this.scene);
        const diffusepic2 = new Texture("./assets/textures/1k/1A.jpg",this.scene,false,false);
        pic2.diffuseTexture = diffusepic2;
        pic2.diffuseTexture.hasAlpha = true;
        model.meshes[3].material = pic2; 

        this.scene.removeMesh(model.meshes[16]);
        this.scene.removeMesh(model.meshes[17]);
        this.scene.removeMesh(model.meshes[19]);
        this.scene.removeMesh(model.meshes[18]);
        this.scene.removeMesh(model.meshes[20]);
  
    this.scene.executeWhenReady(() => this.engine.hideLoadingUI());    
  }
  }